module.exports = __webpack_public_path__ + "img/pre-consult-avatar.e945abd0.png";